<div>
    <span [class.placeholder]="photos == []">
          {{photos?.selectedImages?.length > 0
            ? label
            : placeholder}}
    </span>
    <i class="fa"
        [class.fa-cloud-upload]="!download"
        [class.fa-cloud-download]="download">
    </i>
</div>